document.addEventListener("DOMContentLoaded", function () {
  // Zapri/odpri accordion gumbe v drawerju
  document.querySelectorAll('.drawer-accordion-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const details = btn.parentElement;
      const content = details.querySelector('.drawer-accordion-content');
      if (details.open) {
        details.open = false;
        content.style.maxHeight = "0px";
      } else {
        // zapri vse ostale
        document.querySelectorAll('.drawer-accordion-btn').forEach(otherBtn => {
          if (otherBtn !== btn) {
            const od = otherBtn.parentElement;
            od.open = false;
            od.querySelector('.drawer-accordion-content').style.maxHeight = "0px";
          }
        });
        details.open = true;
        // animiraj height
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
  // Ko se zapira hamburger/drawer, resetiraj vse
  const drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      if (!drawer.open) {
        document.querySelectorAll('.drawer-accordion-btn').forEach(btn => {
          const d = btn.parentElement;
          d.open = false;
          d.querySelector('.drawer-accordion-content').style.maxHeight = "0px";
        });
      }
    });
  }
  // ob loadu vsi collapse
  document.querySelectorAll('.drawer-accordion-content')
    .forEach(c => c.style.maxHeight = "0px");
});
